<template>
  <svg xmlns="http://www.w3.org/2000/svg" :class="classes" viewBox="0 0 16 16">
   <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
   <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
</svg>
</template>

<script>
export default {
   props: {
      color: {
         type: String,
         default: 'light',
         validator: value => [ "primary","secondary","success","info","light","dark","danger", ].includes(value),
      },
      size: {
         type: String,
         default: 'medium',
         validator: value => [ "x-small","small", "medium", "large","x-large"].includes(value),
      },
      spinning: {
         type: Boolean,
         default: false,
      }
   },
   computed: {
      classes()
      {
         return {
            [`${this.size}`] : true,
            [`${this.color}`]: true,
            'loading-icon': true,
            'spinning': this.spinning,
         };
      }
   }
}
</script>

<style lang="scss" scoped>
.loading-icon {
   @include setIconSizeClasses();
   @include setIconColorClasses();
   &.spinning {
      animation: spin 1s linear infinite;
   }
}
@keyframes spin {
   from {
      transform:rotate(0deg);
   }
   to {
      transform:rotate(360deg);
   }
}
</style>